import { render, staticRenderFns } from "./PickFiles.vue?vue&type=template&id=1e477af6&scoped=true&"
import script from "./PickFiles.vue?vue&type=script&lang=js&"
export * from "./PickFiles.vue?vue&type=script&lang=js&"
import style0 from "./PickFiles.vue?vue&type=style&index=0&id=1e477af6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e477af6",
  null
  
)

export default component.exports